import { createBaseApi } from "../baseApi";
import PayloadModel from "model/_payload/payload.schema";
import { CampaignModel } from "model/campaigns/campaign.schema";
import { CampaignsModel } from "model/campaigns/campaigns.schema";

export const campaignsApi = createBaseApi("campaign", "/campaigns").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Campaigns
    getCampaigns: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "",
          method: "GET",
          params: payload,
        };
      },
      providesTags: ["Campaigns"],
      transformResponse: (response) => {
        return CampaignsModel.jsonToModel(response);
      },
    }),

    getCampaignById: builder.query({
      query: (id) => {
        return {
          url: `${id}`,
          method: "GET",
        };
      },
      providesTags: ["Campaigns"],
      transformResponse: (response) => {
        return CampaignModel.jsonToModel(response.data);
      },
    }),

    addCampaign: builder.mutation({
      query: (payload) => {
        return {
          url: "",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Campaigns"],
      transformResponse: (response) => {
        return response;
      },
    }),

    // Update Profile
    updateCampaign: builder.mutation({
      query: (payload) => ({
        url: `${payload.id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Campaigns"],
      transformResponse: (response) => CampaignModel.jsonToModel(response.data),
    }),

    // Delete Campaign
    deleteCampaign: builder.mutation({
      query: (id) => {
        return {
          url: `${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Campaigns"],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { useGetCampaignsQuery, useGetCampaignByIdQuery, useAddCampaignMutation, useUpdateCampaignMutation, useDeleteCampaignMutation } = campaignsApi;
